export default "__VITE_ASSET__DAK7Tnk6__"